import React, { Component } from 'react'
import styled from "styled-components";
import ReactDOM from 'react-dom';
import SectionTitle from "./SectionTitle";

const Container = styled.section`
  padding-bottom: 20px;
  padding-top: 5px;

  > div.hidden {
    display: none;
  }
`;

class Section extends Component {

    constructor(props) {
        super(props);
        this.state = {childrenHidden: props.childrenHidden || false};
    }


    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        if(this.props.sectionTitle && this.props.showLink){
            var sectionTitle = domNode.querySelectorAll('h2[aria-expanded][aria-controls]');
            var be = new window.ButtonExpand(sectionTitle[0]);
            be.init();
        }
    }

    render() {
        return (
            <Container aria-label={this.props.sectionTitle} className={this.props.className || 'award-view'}>
                {this.props.sectionTitle &&
                    <SectionTitle title={this.props.sectionTitle} 
                        sectionId={this.props.sectionId}
                        showLink={this.props.showLink}
                        expanded={!this.state.childrenHidden}
                        showSectionLink={this.props.showSectionLink}
                        hideSectionLink={this.props.hideSectionLink}  
                        showSectionLinkForMobile={this.props.showSectionLinkForMobile}
                        hideSectionLinkForMobile={this.props.hideSectionLinkForMobile}/>
                }
                <div id={this.props.sectionId}>
                    {this.props.children}
                </div> 
            </Container>
        )
    }
}

export default Section;
